<template>
    <va-card class="flex mb-4">
        <va-card-title style="height: 30px; padding: 5px; padding-left: 20px"
            >提出新需求</va-card-title
        >
        <va-card-content>
            <div>
                <div>
                    <vxe-form :data="toolbar.formData">
                        <vxe-form-item
                            title="关键字"
                            field="searchKey"
                            :item-render="{}"
                        >
                            <template #default="{ data }">
                                <vxe-input
                                    v-model="data.searchKey"
                                    placeholder="请输入开发编号或数字员工名称"
                                    clearable
                                ></vxe-input>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item title="状态" :item-render="{}">
                            <template #default="{ data }">
                                <vxe-select
                                    v-model="data.status"
                                    :options="toolbar.allStatus"
                                    placeholder="全部"
                                    clearable
                                    style="width: 140px"
                                >
                                </vxe-select>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item>
                            <template #default>
                                <vxe-button
                                    status="primary"
                                    @click="findReqData"
                                    @keyup.enter="findReqData"
                                    >查询</vxe-button
                                >
                                <vxe-button @click="clear">重置</vxe-button>
                                <vxe-button status="success" @click="addRequire"
                                    >新增</vxe-button
                                >
                                <vxe-button @click="exportDataEvent"
                                    >导出</vxe-button
                                >
                            </template>
                        </vxe-form-item>
                    </vxe-form>
                </div>
                <div style="overflow: hidden; height: 100%">
                    <vxe-table
                        stripe
                        class="mytable-scrollbar"
                        :data="tableData"
                        :height="tableHeight"
                        show-overflow
                        :row-config="{
                            height: 36,
                            isHover: true,
                            isCurrent: true,
                        }"
                        ref="xTable1"
                    >
                        <vxe-column
                            type="seq"
                            field="Id"
                            title="序号"
                            width="50"
                        ></vxe-column>
                        <vxe-column title="删除" width="50">
                            <template #default="{ row }">
                                <vxe-button
                                    type="text"
                                    icon="fa fa-trash-o"
                                    @click="removeReqRowEvent(row)"
                                ></vxe-button>
                            </template>
                        </vxe-column>
                        <vxe-column title="编辑" width="50" show-overflow>
                            <template #default="{ row }">
                                <vxe-button
                                    v-if="
                                        row.status == '0' ||
                                        row.status == '3' ||
                                        row.status == '4'
                                    "
                                    type="text"
                                    icon="fa fa-edit"
                                    @click="editReqEvent(row)"
                                ></vxe-button>
                                <vxe-button
                                    v-else
                                    type="text"
                                    icon="fa fa-search"
                                    @click="editReqEvent(row)"
                                ></vxe-button>
                            </template>
                        </vxe-column>
                        <vxe-column
                            title="状态"
                            width="160"
                            align="center"
                            resizable
                        >
                            <template #default="{ row }">
                                <vxe-button
                                    v-bind:class="{
                                        active: row.statusName === '已审核',
                                        error: row.statusName.includes('驳回'),
                                    }"
                                    type="text"
                                    @click="showAuditList(row)"
                                    >{{ row.statusName }}
                                </vxe-button>
                            </template>
                        </vxe-column>
                        <vxe-column
                            field="processID"
                            title="开发编号"
                            width="130"
                            sortable
                            show-overflow
                        ></vxe-column>
                        <vxe-column
                            field="processName"
                            title="数字员工名称"
                            width="180"
                            show-overflow
                            resizable
                            sortable
                        ></vxe-column>
                        <vxe-column
                            field="processDesc"
                            title="工作场景描述"
                            width="200"
                            show-overflow
                            resizable
                            sortable
                        ></vxe-column>
                        <vxe-column
                            field="sceneBussValue"
                            title="场景业务价值"
                            width="200"
                            show-overflow
                            resizable
                            sortable
                        ></vxe-column>
                        <vxe-column
                            field="createDate"
                            title="创建日期"
                            width="120"
                            sortable
                            :formatter="formatTime"
                        ></vxe-column>
                        <vxe-column
                            field="bussName"
                            title="申请人姓名"
                            width="120"
                            sortable
                        ></vxe-column>
                        <vxe-column
                            field="divison"
                            title="总部"
                            width="100"
                            sortable
                            show-overflow
                        ></vxe-column>
                        <vxe-column
                            field="dept"
                            title="部门"
                            width="100"
                            resizable
                            sortable
                            show-overflow
                        ></vxe-column>
                        <vxe-column
                            field="office"
                            title="科室"
                            width="100"
                            sortable
                            show-overflow
                        ></vxe-column>
                        <vxe-column
                            field="winMan"
                            title="部门窗口"
                            width="100"
                            sortable
                        ></vxe-column>
                        <vxe-column
                            field="leader"
                            title="科长"
                            width="100"
                            sortable
                        ></vxe-column>
                        <vxe-column
                            field="bussEmail"
                            title="申请人邮箱"
                            width="180"
                            show-overflow
                            sortable
                            resizable
                        ></vxe-column>
                        <vxe-column
                            field="tutorName"
                            title="辅导老师"
                            width="100"
                            show-overflow
                            sortable
                            resizable
                        ></vxe-column>
                        <vxe-column
                            field="scenceName"
                            title="场景担当"
                            width="100"
                            show-overflow
                            sortable
                            resizable
                        ></vxe-column>
                        <vxe-column
                            field="planPlatformName"
                            title="计划部署平台"
                            width="140"
                            show-overflow
                            sortable
                            resizable
                        ></vxe-column>
                        <vxe-column
                            field="selfLevelName"
                            title="优先级"
                            width="120"
                        ></vxe-column>
                        <vxe-column
                            field="planPublishDate"
                            title="计划上线时间"
                            width="160"
                            sortable
                            :formatter="formatTime"
                        ></vxe-column>
                        <vxe-column
                            field="requireNo"
                            title="需求编号"
                            width="130"
                            sortable
                            show-overflow
                        ></vxe-column>
                    </vxe-table>
                </div>
                <div>
                    <vxe-pager
                        background
                        v-model:current-page="tablePager.currentPage"
                        v-model:page-size="tablePager.pageSize"
                        :total="tablePager.totalResult"
                        @page-change="handlePageChange"
                        :page-sizes="[
                            10,
                            20,
                            100,
                            { label: '全部数据', value: 10000 },
                        ]"
                        :layouts="[
                            'PrevJump',
                            'PrevPage',
                            'JumpNumber',
                            'NextPage',
                            'NextJump',
                            'Sizes',
                            'FullJump',
                            'Total',
                        ]"
                    >
                    </vxe-pager>
                </div>
            </div>

            <vxe-modal title="选择用户" v-model="iShowSelectUser" width="640">
                <template #default>
                    <div>
                        <vxe-form>
                            <vxe-form-item title="关键字" :item-render="{}">
                                <template #default>
                                    <vxe-input
                                        v-model="userTablePager.searchKey"
                                        placeholder="请输入姓名或邮箱"
                                        clearable
                                    ></vxe-input>
                                </template>
                            </vxe-form-item>
                            <vxe-form-item>
                                <template #default>
                                    <vxe-button
                                        @click="findUserData"
                                        @keyup.enter="findUserData"
                                        >查询</vxe-button
                                    >
                                </template>
                            </vxe-form-item>
                        </vxe-form>
                    </div>
                    <div>
                        <vxe-table
                            class="mytable-scrollbar"
                            :data="dtUser"
                            ref="xTableUser"
                            height="300"
                            @cell-dblclick="chooseUser"
                            highlight-hover-row
                            highlight-current-row
                        >
                            <vxe-column
                                type="seq"
                                field="Id"
                                title="序号"
                                width="50"
                            ></vxe-column>
                            <vxe-column
                                field="UserName"
                                title="姓名"
                                width="120"
                                sortable
                            ></vxe-column>
                            <vxe-column
                                field="JobZb"
                                title="总部"
                                width="100"
                                sortable
                            ></vxe-column>
                            <vxe-column
                                field="JobName"
                                title="部门"
                                width="120"
                                sortable
                                resizable
                            ></vxe-column>
                            <vxe-column
                                field="UserMail"
                                title="邮箱"
                                width="200"
                                sortable
                                resizable
                            ></vxe-column>
                            <vxe-column
                                field="uid"
                                title="uid"
                                width="10"
                                :visible="false"
                            ></vxe-column>
                        </vxe-table>
                    </div>
                    <div>
                        <vxe-pager
                            background
                            v-model:current-page="userTablePager.currentPage"
                            v-model:page-size="userTablePager.pageSize"
                            :total="userTablePager.totalResult"
                            @page-change="handlePageChangeUser"
                            size="small"
                        >
                        </vxe-pager>
                    </div>
                </template>
            </vxe-modal>
            <vxe-modal
                title="审核记录"
                v-model="isShowAuditList"
                width="500"
                height="600"
            >
                <template #default>
                    <div>
                        <MyAuditLine :auditrecord-list="dtAudit"></MyAuditLine>
                    </div>
                </template>
            </vxe-modal>
            <addNewRequire
                ref="addNewRequireRef"
                @flashReqList="findReqData"
            ></addNewRequire>
        </va-card-content>
    </va-card>
</template>

<script>
import { reactive, ref } from "vue";
import { VXETable } from "vxe-table";
import Qs from "qs";
import XEUtils from "xe-utils";
import MyAuditLine from "../myPlug/MyAuditLine";
import addNewRequire from "../dashboardNew/addNewRequire.vue";

export default {
    name: "NewRequire",
    components: { MyAuditLine, addNewRequire },
    data() {
        const activeKey = ref("1");

        const formInput = reactive({
            title: "提出一个新需求",
            isShow: false,
            planPlatform: [],
            winMan: "",
            winManUID: "",
            formData: {
                Id: "",
                processID: "",
                processName: "",
                processDesc: "",
                bussName: "",
                divison: "",
                status: "",
                dept: "",
                office: "",
                bussEmail: "",
                selfLevel: "2", //优先级自判 中
                requireNo: "",
                leader: "",
                leaderUID: "",
                winMan: "",
                winManUID: "",
                devDifficulty: "1", //默认低
                planPublishDate: "",
                sceneBussValue: "",
                isNeedTutor: "",
                planPlatform: "",
            },
            formRules: {
                processID: [{ required: false, message: "开发编号不能为空" }],
                processName: [
                    { required: true, message: "请输入数字员工名称" },
                ],
                processDesc: [
                    { required: true, message: "请输入工作场景描述" },
                ],
                bussName: [{ required: true, message: "请输入姓名" }],
                divison: [{ required: true, message: "请输入总部" }],
                dept: [{ required: true, message: "请输入部门" }],
                office: [{ required: true, message: "请输入科室" }],
                bussEmail: [{ required: true, message: "请输入邮箱" }],
                selfLevel: [{ required: true, message: "请选择优先级" }],
                winMan: [{ required: true, message: "请选择部门窗口人" }],
                leader: [{ required: true, message: "请选择科长" }],
                planPublishDate: [
                    { required: true, message: "请选择计划上线时间" },
                ],
                sceneBussValue: [
                    { required: true, message: "请输入场景业务价值" },
                ],
                isNeedTutor: [
                    { required: true, message: "请选择是否需要辅导老师" },
                ],
                planPlatform: [
                    { required: true, message: "请选择计划部署平台" },
                ],
            },
        });
        const tablePager = reactive({
            currentPage: 1,
            pageSize: 10,
            totalResult: 0,
        });

        const toolbar = reactive({
            loading: false,
            allStatus: [],
            formData: {
                status: "",
                searchKey: "",
            },
        });
        const userTablePager = reactive({
            currentPage: 1,
            pageSize: 10,
            totalResult: 0,
            searchKey: "",
        });
        const addNewRequireRef = ref(null);
        return {
            formInput,
            userTablePager,
            tableData: null,
            dtUser: null,
            tablePager,
            toolbar,
            userSelectType: 2, //1 多选 2 单选
            iShowSelectUser: false,
            selectType: "",
            editType: "1", //编辑类型 1 新增 2 维护
            isShowAuditList: false,
            dtAudit: null,
            activeKey,
            submitLoading: false,
            tempDisable: true,
            tableHeight: 0,
            allInputDisable: false,
            isViewFooter: true,
            addNewRequireRef,
        };
    },
    methods: {
        async removeReqRowEvent(row) {
            if (row.status === "1") {
                await VXETable.modal.message({
                    content: "窗口审核中不能删除，请先驳回",
                    status: "error",
                });
                return;
            }
            if (row.status === "2") {
                await VXETable.modal.message({
                    content: "场景组审核中不能删除，请先驳回",
                    status: "error",
                });
                return;
            }
            if (row.status === "5") {
                await VXETable.modal.message({
                    content: "已审核不能删除",
                    status: "error",
                });
                return;
            }

            const type = await VXETable.modal.confirm("您确定要删除该数据?");
            const $grid = this.$refs.xTable1;
            if (type === "confirm") {
                this.$api.newRequireManageAPI
                    .deleteRequires(Qs.stringify({ reqId: row.Id }))
                    .then((res) => {
                        if (res.data.Success === false) {
                            VXETable.modal.message({
                                content: res.data.Message,
                                status: "error",
                            });
                            return;
                        }
                        VXETable.modal.message({
                            content: "删除成功",
                            status: "success",
                        });

                        $grid.remove(row);
                    })
                    .catch((error) => {
                        console.log(error);
                    });
            }
        },
        addRequire() {
            this.$refs.addNewRequireRef.openModal();
        },
        editReqEvent(row) {
            this.$refs.addNewRequireRef.editReqEvent(row, 1);
        },

        findUserData() {
            const params = {
                uid: this.$store.state.userID,
                email: this.$store.state.email,
                currentPage: this.userTablePager.currentPage,
                pageSize: this.userTablePager.pageSize,
                searchKey: [this.userTablePager.searchKey, ""],
            };
            this.$api.systemManageAPI
                .getUserList(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success == false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
                        return;
                    }
                    // console.log(res.data.Data);
                    this.dtUser = res.data.Data.dataTable;
                    this.userTablePager.currentPage = res.data.Data.currentPage;
                    this.userTablePager.pageSize = res.data.Data.pageSize;
                    this.userTablePager.totalResult = res.data.Data.totalResult;
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        selectUser(type) {
            this.userSelectType = type;
            this.userTablePager.searchKey = "";
            this.findUserData();
            this.iShowSelectUser = true;
        },
        //选择用户
        chooseUser() {
            const $table = this.$refs.xTableUser;
            const record = $table.getCurrentRecord();
            if (record == null || record.length == 0) {
                VXETable.modal.message({
                    content: "请选择一行数据",
                    status: "info",
                });
                return;
            }
            this.formInput.formData.leader = record.UserName;
            this.formInput.formData.leaderUID = record.uid;
            this.iShowSelectUser = false;
        },
        findReqData() {
            const params = {
                uid: this.getUserId,
                email: this.getUserEmail,
                currentPage: this.tablePager.currentPage,
                pageSize: this.tablePager.pageSize,
                searchKey: [
                    this.toolbar.formData.searchKey,
                    "1",
                    this.toolbar.formData.status,
                ], //1 表示只查本人总部的需求
            };
            this.$api.newRequireManageAPI
                .getRequireList(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success == false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
                        return;
                    }
                    // console.log(res.data.Data);
                    this.tableData = res.data.Data.dataTable;
                    this.tablePager.currentPage = res.data.Data.currentPage;
                    this.tablePager.pageSize = res.data.Data.pageSize;
                    this.tablePager.totalResult = res.data.Data.totalResult;
                    this.tableHeight = this.$calTableHeight(
                        res.data.Data.dataTable.length
                    );
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        handlePageChange() {
            this.findReqData();
        },
        handlePageChangeUser() {
            this.findUserData();
        },

        bindPlatform() {
            const params = {
                uid: this.$store.state.userID,
                email: this.$store.state.email,
                currentPage: 1,
                pageSize: 100,
                searchKey: [""],
            };
            this.$api.digitalDictManageAPI
                .getDeployPlatformList(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success == false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });

                        return;
                    }
                    this.formInput.planPlatform = [];
                    for (const item of res.data.Data.dataTable) {
                        this.formInput.planPlatform.push({
                            value: item.code,
                            label: item.name,
                        });
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        bindHeadquarterWin() {
            const params = {
                uid: this.$store.state.userID,
                email: this.$store.state.email,
                currentPage: 1,
                pageSize: 100,
                searchKey: ["", this.$store.state.jobZb],
            };
            this.$api.digitalDictManageAPI
                .getHeadquarterWinOne(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success == false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });

                        return;
                    }
                    if (
                        Array.isArray(res.data.Data.dataTable) &&
                        res.data.Data.dataTable.length > 0
                    ) {
                        this.formInput.winMan =
                            res.data.Data.dataTable[0].userName;
                        this.formInput.winManUID =
                            res.data.Data.dataTable[0].uid;
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        bindAllStatus() {
            const params = {
                uid: this.$store.state.userID,
                email: this.$store.state.email,
                currentPage: "",
                pageSize: "",
                searchKey: ["26"],
            };
            this.$api.systemManageAPI
                .getLookupValue(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success == false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
                        return;
                    }
                    // console.log(res.data.Data);
                    this.toolbar.allStatus = [];
                    for (const item of res.data.Data) {
                        this.toolbar.allStatus.push({
                            value: item.LookupValueCode,
                            label: item.LookupValueName,
                        });
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        cellClassName() {
            return "row-center";
        },
        showAuditList(row) {
            const params = {
                uid: this.getUserId,
                email: this.getUserEmail,
                currentPage: 1,
                pageSize: 1,
                searchKey: [row.Id], //
            };
            this.$api.requireManageAPI
                .getAuditRecordList(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success == false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
                        return;
                    }
                    // console.log(res.data.Data);
                    this.dtAudit = res.data.Data;
                    debugger;
                    this.isShowAuditList = true;
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        formatTime({ cellValue, row, column }) {
            return XEUtils.toDateString(cellValue, "yyyy-MM-dd");
        },
        addAuditRecord(bussId, status) {
            //写审核日志
            const params = {
                auditBuId: bussId,
                auditMan: this.getUserName,
                auditManUid: this.getUserId,
                auditStatus: status, //0发起 1 通过 2 驳回
                auditOpinion: "",
                auditNode: "审核发起",
            };
            this.$api.requireManageAPI
                .addAuditRecord(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success === false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
                        return;
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        cellStyle(row, column) {
            if (column.property === "statusName") {
                if (row.statusName === "已驳回") {
                    return {
                        backgroundColor: "#187",
                    };
                }
            }
        },
        calManYear() {
            if (
                this.formInput.formData.manSingleTime &&
                this.formInput.formData.manFrequency &&
                this.formInput.formData.participantNum
            ) {
                this.formInput.formData.manYear =
                    this.formInput.formData.manSingleTime *
                    this.formInput.formData.manFrequency *
                    this.formInput.formData.participantNum *
                    12;
            }
        },
        clear() {
            this.toolbar.formData.searchKey = "";
            this.toolbar.formData.status = "";
        },
        exportDataEvent() {
            const $table = this.$refs.xTable1;
            $table.exportData({ type: "csv" });
        },
    },
    mounted() {
        this.bindPlatform();
        this.bindHeadquarterWin();
        this.bindAllStatus();
        this.findReqData();
    },
    unmounted() {
        //  window.removeEventListener("keydown", this.keydown, false);
    },
    computed: {
        getUserName() {
            return this.$store.state.userName;
        },
        getJobZb() {
            return this.$store.state.jobZb;
        },
        getJobName() {
            return this.$store.state.jobName;
        },
        getUserEmail() {
            return this.$store.state.email;
        },
        getUserId() {
            return this.$store.state.userID;
        },
    },
};
</script>

<style lang="scss" scoped>
.mytable-style .vxe-body--column.col-red {
    background-color: red;
    color: #fff;
}

.active {
    color: green;
}

.error {
    color: red;
}

.audit {
    color: blue;
}
</style>

<style type="text/css">
td.vxe-body--column {
    vertical-align: middle;
}
</style>
